import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from 'src/app/components/modal/modal.service';
import { DataModalComponent } from '../modal/data-modal/data-modal.component';
import { Subscription } from 'rxjs';
import { AppConstants } from 'src/app/constants/app-constants';
import { BundlesService } from 'src/app/pages/bundles/bundles.service';
import { ToastService } from 'src/app/components/toast/toast.service';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { BundlePreviewModalComponent } from '../modal/bundle-preview-modal/bundle-preview-modal.component';
import { resolveCppOrientationThumbnail, resolveEpgItemThumbnail } from 'src/app/utils/category-content-thumbnail';

/** Publish preview `item` may be flat (API) or under `metadata`. */
function flattenPreviewItemForThumb(item: any): any {
    if (!item || typeof item !== 'object') {
        return item;
    }
    const m = item.metadata;
    if (m && typeof m === 'object') {
        return { ...m, ...item };
    }
    return item;
}

@Component({
    selector: 'app-cards',
    templateUrl: './cards.component.html',
    styleUrls: ['./cards.component.scss'],
})
export class CardsComponent {
    @Input() item: any;
    @Input() orientation: string | undefined;
    @Input() cardType: string | undefined;
    @Input() isCollection: any;
    @Input() isBundle: any;
    @Input() showCollectionBoolean: boolean = false;
    @Output() showCardEvent = new EventEmitter<any>();
    @Output() removeCardEvent = new EventEmitter<any>();
    @Output() showCarousalEvent = new EventEmitter<any>();
    @Output() hideCarousalEvent = new EventEmitter<any>();
    @Output() cardClickEvent = new EventEmitter<any>();

    showCardBoolean: boolean = false;
    showScreenIcon: boolean = false;
    showScreenIconBundle: boolean = false;
    isMultiSchedule: boolean = false;
    bundlesSubscription$?: Subscription;
    showBundleBoolean: boolean = false;
    bundleDisplayData: any;
    // showCollectionCarousal: boolean = false;
    constructor(
        private modal: ModalService,
        private bundlesService: BundlesService,
        private toast: ToastService,
        private spinner: SpinnerService
    ) {}

    ngOnInit() {
        this.bundlesSubscription$ = this.bundlesService.bundles$.subscribe((params: any) => {
            if (params) {
                switch (params.type) {
                    case 'BUNDLES_PREVIEW_ID_GET_SUCCESSFUL':
                        console.log('BUNDLES PREVIEW GET DATA', params.data?.items);
                        this.modal.openModal({
                            component: BundlePreviewModalComponent,
                            data: params.data,
                            prefix: 'category-visible-table-data',
                        });

                        break;

                    case 'BUNDLES_PREVIEW_ID_GET_FAILED':
                        console.log('ERROR', params.data.error.message);
                        this.toast.showToast(params.data.error.message, 'error');
                        setTimeout(() => {
                            this.spinner.destroySpinner();
                        }, 3000);
                        break;
                }
            }
        });
        console.log(this.showCollectionBoolean, 'ITEMS', this?.item);
        if (this.item?.source == 'Screen') {
            this.showScreenIcon = true;
        } else {
            this.showScreenIcon = false;
        }
        if (this.item?.source == 'Bundle') {
            this.showScreenIconBundle = true;
        } else {
            this.showScreenIconBundle = false;
        }
        if (this.item?.schedule?.length > 0 && this.item?.schedule != '24x7') {
            this.isMultiSchedule = true;
        } else {
            this.isMultiSchedule = false;
        }

        // console.log('orientation', this.orientation);
    }

    // ngOnChanges() {
    //     this.showCardBoolean = false;
    // }

    showCard(data: any) {
        console.log('showCardData here', data);
        this.showCardBoolean = true;
        this.showCardEvent.emit(data);
    }
    removeCard(data: any) {
        this.showCardBoolean = false;
        this.removeCardEvent.emit(data);
    }

    showCollectionCard(item: any) {
        this.showCollectionBoolean = true;
        const data = { item: item, orientation: this.orientation };
        this.showCarousalEvent.emit(data);
    }

    hideCollectionCard(item: any) {
        this.showCollectionBoolean = false;
        const data = { item: item, orientation: this.orientation };
        this.hideCarousalEvent.emit(data);
    }

    handleCardClick() {
        this.cardClickEvent.emit(this.item);
    }

    handleBundleCard(item: any) {
        console.log('showCardData Bundle phere', item);
        this.bundlesService.getBundlesPreviewData(this?.item?.item);
    }

    handleModalClick() {
        console.log('handleModalClick');
        this.modal.openModal({
            component: DataModalComponent,
            data: {
                data: this?.item?.schedule,
                pageType: 'multiSchedule',
            },
            prefix: 'audit-table-data',
        });
    }

    getImageUrl(url: any) {
        return url;
    }

    /** Single resolved URL for publish/PDP preview (EPG portrait → assets['3:4'], etc.). */
    getPreviewItemThumbUrl(item: any): string {
        const data = flattenPreviewItemForThumb(item);
        const s = (data?.source ?? '').toString().toLowerCase();
        if (s === 'epg') {
            return resolveEpgItemThumbnail(data, this.orientation);
        }
        return resolveCppOrientationThumbnail(data, this.orientation);
    }

    ngOnDestroy() {
        this.bundlesSubscription$?.unsubscribe();
    }
}
